import { observer } from 'mobx-react-lite'
import { Avatar, AutomatedAvatar, TypingIndicator, Icon } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type ChatbotConversationMessage } from 'entities/Chatbot'

import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export interface IMessageProps {
  message: ChatbotConversationMessage
}

export const MessageOutgoing = observer(({ message }: IMessageProps) => {
  const { usersStore } = useEntitiesContext()
  const user = usersStore.user
  const avatarInfo = user?.avatarInfo || {}

  return (
    <div className={styles.message} data-outgoing>
      <div className={styles.messageAvatar}>
        <Avatar info={avatarInfo} />
      </div>
      <div className={styles.messageBody}>
        <div className={styles.messageBodyText}>{message.body}</div>
        <div className={styles.messageBodyDate}>
          {uiStore.dayjs(message.date).format(DayjsFormats.time)}
        </div>
      </div>
    </div>
  )
})

export const MessageOutgoingLoading = observer(() => {
  const { usersStore } = useEntitiesContext()
  const user = usersStore.user
  const avatarInfo = user?.avatarInfo || {}

  return (
    <div className={styles.message} data-outgoing>
      <div className={styles.messageAvatar}>
        <Avatar info={avatarInfo} />
      </div>
      <div className={styles.messageBody}>
        <div className={styles.messageBodyText}>
          <TypingIndicator />
        </div>
      </div>
    </div>
  )
})

export const MessageIncoming = observer(
  ({ message, isBookAppointment }: IMessageProps & { isBookAppointment?: boolean }) => {
    return (
      <div className={styles.message}>
        <div className={styles.messageAvatar}>
          {isBookAppointment ? (
            <Icon icon={'stars'} fontSize={22} color={'var(--content-brand-primary)'} />
          ) : (
            <AutomatedAvatar />
          )}
        </div>
        <div className={styles.messageBody}>
          <div className={styles.messageBodyText}>{message.body}</div>
          <div className={styles.messageBodyDate}>
            {uiStore.dayjs(message.date).format(DayjsFormats.time)}
          </div>
        </div>
      </div>
    )
  }
)

export const MessageIncomingLoading = observer(
  ({ isBookAppointment }: { isBookAppointment?: boolean }) => (
    <div className={styles.message}>
      <div className={styles.messageAvatar}>
        {isBookAppointment ? (
          <Icon icon={'stars'} fontSize={22} color={'var(--content-brand-primary)'} />
        ) : (
          <AutomatedAvatar />
        )}
      </div>
      <div className={styles.messageBody}>
        <div className={styles.messageBodyText}>
          <TypingIndicator />
        </div>
      </div>
    </div>
  )
)
